module.exports = __webpack_public_path__ + "static/media/homePage-animation.mp4";